var map = {
	"./account.svg": 198,
	"./arrow-minus.svg": 199,
	"./arrow-plus.svg": 200,
	"./check.svg": 201,
	"./close.svg": 202,
	"./email.svg": 203,
	"./facebook.svg": 204,
	"./instagram.svg": 205,
	"./mail.svg": 206,
	"./messenger.svg": 207,
	"./next.svg": 208,
	"./phone.svg": 209,
	"./prev.svg": 210,
	"./telegram.svg": 211,
	"./twitter.svg": 212,
	"./vk.svg": 213,
	"./whatsup.svg": 214,
	"./youtube.svg": 215,
	"./zen.svg": 216
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;